"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NO_DATA_PLACEHOLDER_CATEGORY_KEY = 'base';
exports.NO_DATA_PLACEHOLDER_COMPONENT_KEY = 'noDataPlaceholder';